import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getInsights } from "../services";
import type { CopilotInsightListItem, InsightQueryParams } from "../types";
import { mapInsightListItem } from "../utils";
import { insightQueryKeys } from "./insight-query-keys";

export type InsightsListQueryData = {
	items: CopilotInsightListItem[];
	totalCount: number;
	pageSize: number;
	currentPage: number;
	totalPages: number;
};

export const useInsightsQuery = (params: InsightQueryParams) =>
	useQuery({
		queryKey: insightQueryKeys.list(params),
		queryFn: async (): Promise<InsightsListQueryData> => {
			const raw = await getInsights(params);
			return {
				items: raw.items.map(mapInsightListItem),
				totalCount: raw.totalCount,
				pageSize: raw.pageSize,
				currentPage: raw.currentPage,
				totalPages: raw.totalPages,
			};
		},
		placeholderData: keepPreviousData,
	});
